
import { useEffect, useRef } from 'react';
import * as echarts from 'echarts';

export default function NightingaleChart({ indicators }) {

    console.log('www', indicators);

    const ref = useRef(null);


    const indicators33 = [
        { indicator: 'Gdp', correlation: 0.817 },
        { indicator: 'Unemployment Rate', correlation: 0.815 },
        { indicator: 'Cpi', correlation: 0.813 },
        { indicator: 'Consumer Sentiment', correlation: 0.428 }
    ];

    useEffect(() => {
        const chart = echarts.init(ref.current);

        chart.setOption({
            title: {
                text: '',
                left: 'center'
            },
            legend: {
                top: 0, textStyle: {
                    color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
                },
            },
            toolbox: {
                show: false,
                feature: {
                    dataView: { show: true, readOnly: false },
                    saveAsImage: { show: true },
                    restore: { show: true }
                }
            },
            series: [
                {
                    name: 'Correlation',
                    type: 'pie',
                    roseType: 'area',          // Nightingale!
                    radius: window.innerWidth < 568 ? [10, 80] : [20, 160],
                    center: ['50%', '50%'],
                    itemStyle: { borderRadius: 6 },
                    label: {
                        position: 'inside',
                        textStyle: {
                            color: window.matchMedia('(prefers-color-scheme: dark)').matches ? '#eee' : '#666',
                        },
                        formatter: ({ data }) =>
                            `${data.name}\n${data.value.toFixed(1)}`
                    },
                    data: indicators.map(i => ({
                        name: i.indicator,
                        value: i.correlation_with_revenue * 100, // scale for visual impact
                        raw: i.correlation_with_revenue          // keep original for tooltip/label
                    }))
                }
            ],
            tooltip: {
                trigger: 'item',
                formatter: p =>
                    `${p.name}<br/>Correlation with Revenue: <b>${p.data.value.toFixed(1)}</b>`
            }
        });

        const resize = () => chart.resize();
        window.addEventListener('resize', resize);
        return () => {
            window.removeEventListener('resize', resize);
            chart.dispose();
        };
    }, []);

    return <div ref={ref}
        className=""
        style={{
            height: window.innerWidth < 568 ? '270px' : '400px',
            width: window.innerWidth < 568 ? '300px' : '100%',
        }} />;
}
